module.exports = __webpack_public_path__ + "img/v3-header.b6378a72.png";